import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowSplitDown"><Path d="M7.20703 18.207L5.20703 20.207L3.79297 18.793L5.79297 16.793L7.20703 18.207Z" fill="currentColor"/><Path d="M13 11.5859L18 16.5859V13H20V20H13V18H16.5859L11 12.4141V3H13V11.5859Z" fill="currentColor"/><Path d="M10.707 14.707L8.70703 16.707L7.29297 15.293L9.29297 13.293L10.707 14.707Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitDown;
